import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

type IQuestionSubTypelistSlice = {id?:number,topic_name?:string}
export const QuestionSubTypelistSlice = createSlice({
  name: "QuestionSubTypelistSlice",
  initialState: {} as IReduxState<IQuestionSubTypelistSlice[]>,
  reducers: {
    QuestionSubTypelist: (state, _: PayloadAction<IQuestionSubTypelistSlice>) => {
      state.isLoading = true;
    },
    successQuestionSubTypelist: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureQuestionSubTypelist: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearQuestionSubTypelistResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  failureQuestionSubTypelist,
  QuestionSubTypelist,
  successQuestionSubTypelist,
  clearQuestionSubTypelistResponse,
} = QuestionSubTypelistSlice.actions;

export default QuestionSubTypelistSlice.reducer;
